export const aboutData = {
    title: "Who I am",
    description1: "My name's Masham. I am a Full stack developer with a Bachelor of Science (B.S.) in Information Technology from the University of Sargodha and 4 years of software development experience.",
    description2: "I am experienced in web development with ReactJS, NodeJS, RestApi's, GraphQL, NextJS, GatsbyJS and responsive UI.",
    image: 2
}